var exports = {
  "n": "animateBell__BilgoC",
};

module.exports = exports;
